<div t4-tooltip class="t4EntityLink">
    <span class="customerText" style="white-space: nowrap;"><a href="javascript: void(0)" (mouseenter)="show()" (mouseleave)="hide()" (click)="click()"><span #ref><ng-content></ng-content></span><span *ngIf="ref.childNodes.length == 0">{{ displayText }}</span></a></span>
    <div #tooltipContent class="t4Tooltip-container">
        <div class="t4Tooltip-content row" *ngIf="_customer">
            <div class="col-xs-12">
                <label *ngIf="_customer.CompanyName">{{ _customer.CompanyName}}</label><br/>
                <label>{{ _customer.Lastname}}, {{_customer.Firstname}}</label>
                <div>{{ _customer.Address }}<br />{{_customer.ZipCode}} {{_customer.City}}</div>
                <label>{{ 'Turbo.Data.Customer.Phone' | translate : 'Phone'}}</label>
                <div>{{ _customer.MobilePhone }}</div>
                <label>{{ 'Turbo.Data.Customer.Email' | translate : 'Email'}}</label>
                <div><a href="mailto:{{_customer.Email}}" *ngIf="_customer.Email">{{ _customer.Email }}</a></div>
            </div>
        </div>
    </div>
</div>